import { useState, useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTreatments } from '@splitsoftware/splitio-react'
import { getRoutes } from './routes'
import { getParam, getUtmParams } from '~/utils/get-param'
import { windowGlobal } from '~/utils/windowGlobal'
import { safeReferrer } from '~/utils/safe-referrer'
import { SplitIOTreatments } from '~/constants/split-io'

const redirect = url => {
  windowGlobal().location.assign(url)
}

const redirectToReferrer = referrer => {
  redirect(safeReferrer(referrer))
}

const useRoutesNavigate = () => {
  const { search } = useLocation()
  const navigate = useNavigate()
  const [current, setCurrent] = useState()
  const [referrer, setReferrer] = useState(getParam('referrer', search))
  const utmSeachParams = useMemo(() => getUtmParams(search), [])

  const treatments = useTreatments([SplitIOTreatments.isSelectClaimEnabled])
  const { treatment } = treatments[SplitIOTreatments.isSelectClaimEnabled]
  const ROUTES = getRoutes(treatment)

  const goNext = useCallback(() => {
    const { next } = ROUTES[current] || {}

    if (!next) {
      return
    }

    const route = ROUTES[next]

    setCurrent(next)

    if (route.auth && referrer) {
      redirectToReferrer(`${referrer}?${utmSeachParams}`)
      return
    }

    if (route.external) {
      redirect(`${next}?${utmSeachParams}`)
      return
    }

    navigate(next)
  }, [current])

  const goPrev = useCallback(() => {
    const { prev } = ROUTES[current] || {}

    if (!prev) {
      return
    }

    setCurrent(prev)
    navigate(prev)
  }, [current])

  return {
    navigate,
    current,
    referrer,
    setCurrent,
    goNext,
    goPrev,
    setReferrer,
    redirect,
  }
}

export { useRoutesNavigate }
